import axios from 'axios';

// criar uma instancia axios para o endpoint do transporte
const axiosTransporte = axios.create({
  baseURL:  process.env.VUE_APP_API_BASEURL_TRANSPORTE,
  withCredentials: false,
});

// criar uma instancia axios para o endpoint do buffet
const axiosBuffet = axios.create({
  baseURL:  process.env.VUE_APP_API_BASEURL_BUFFET,
  withCredentials: false,
});

// Exportação nomeada
export { axiosTransporte, axiosBuffet };